define(function(require) {
	var d3 = require('d3c');

	var geoRange = d3
		.scaleLinear()
		.domain([-1, 0, 1])
		.range(['#e90000', '#7a7a7a', '#7dc008']);

	var Sentiment = {
		ranges: {
			defaults: {
				defaultcolor: '#000000',
				colors: [
					{
						v: [-1.0, -0.9],
						c: '#d60000'
					},
					{
						v: [-0.9, -0.8],
						c: '#ab0000'
					},
					{
						v: [-0.8, -0.7],
						c: '#960000'
					},
					{
						v: [-0.7, -0.6],
						c: '#780000'
					},
					{
						v: [-0.6, -0.5, true],
						c: '#590000'
					},
					{
						v: [0.5, 0.6],
						c: '#065e00'
					},
					{
						v: [0.6, 0.7],
						c: '#087300'
					},
					{
						v: [0.7, 0.8],
						c: '#0d9e00'
					},
					{
						v: [0.8, 0.9],
						c: '#0fb500'
					},
					{
						v: [0.9, 1.0],
						c: '#0fb500'
					}
				]
			},

			aggregated: {
				defaultcolor: '#000000',
				colors: [
					{
						v: [-1.0, -0.6],
						c: '#d60000'
					},
					{
						v: [-0.6, -0.5],
						c: '#ab0000'
					},
					{
						v: [-0.5, -0.4],
						c: '#960000'
					},
					{
						v: [-0.4, -0.3],
						c: '#780000'
					},
					{
						v: [-0.3, -0.2, true],
						c: '#590000'
					},
					{
						v: [0.2, 0.3],
						c: '#065e00'
					},
					{
						v: [0.3, 0.4],
						c: '#087300'
					},
					{
						v: [0.4, 0.5],
						c: '#0d9e00'
					},
					{
						v: [0.5, 0.6],
						c: '#0fb500'
					},
					{
						v: [0.6, 1.0],
						c: '#11b800'
					}
				]
			},

			infovis: {
				defaultcolor: '#cccccc', // @portal-color-gray-80
				colors: [
					{
						v: [-1.0, -0.6],
						c: '#d60000'
					},
					{
						v: [-0.6, -0.5],
						c: '#ab0000'
					},
					{
						v: [-0.5, -0.4],
						c: '#960000'
					},
					{
						v: [-0.4, -0.3],
						c: '#780000'
					},
					{
						v: [-0.3, -0.2],
						c: '#590000'
					},
					{
						v: [-0.2, 0.2],
						c: '#c8c8c8'
					},
					{
						v: [0.2, 0.3],
						c: '#065e00'
					},
					{
						v: [0.3, 0.4],
						c: '#087300'
					},
					{
						v: [0.4, 0.5],
						c: '#0d9e00'
					},
					{
						v: [0.5, 0.6],
						c: '#0fb500'
					},
					{
						v: [0.6, 1.0],
						c: '#11b800'
					}
				]
			},

			geomap: {
				defaultcolor: '#cccccc', // @portal-color-gray-80
				colors: [
					{
						v: [-1.0, -0.6],
						c: geoRange(-0.8)
					},
					{
						v: [-0.6, -0.5],
						c: geoRange(-0.55)
					},
					{
						v: [-0.5, -0.4],
						c: geoRange(-0.45)
					},
					{
						v: [-0.4, -0.3],
						c: geoRange(-0.35)
					},
					{
						v: [-0.3, -0.2],
						c: geoRange(-0.25)
					},
					{
						v: [-0.2, 0.2],
						c: geoRange(0)
					},
					{
						v: [0.2, 0.3],
						c: geoRange(0.25)
					},
					{
						v: [0.3, 0.4],
						c: geoRange(0.35)
					},
					{
						v: [0.4, 0.5],
						c: geoRange(0.45)
					},
					{
						v: [0.5, 0.6],
						c: geoRange(0.55)
					},
					{
						v: [0.6, 1.0],
						c: geoRange(0.8)
					}
				]
			}
		}
	};

	Sentiment.getColor = function(value, range, def) {
		if (!range) {
			range = 'defaults';
		} else if (range === 'd3') {
			return Sentiment.getD3Color(value);
		} else if (range === 'global') {
			value = parseFloat(value).toFixed(2);
			return Sentiment.getGlobalColor(value);
		}

		var color = Sentiment.ranges[range].colors.filter(function(d) {
			return value >= d.v[0] && value <= d.v[1];
		});

		if (color && color[0]) {
			return color[0].c;
		}

		return def || Sentiment.ranges[range].defaultcolor;
	};

	Sentiment.getD3Color = function(sentiment) {
		var colorScale = Sentiment.getD3Color.scale;
		var color = Math.round(colorScale(sentiment));

		if (sentiment < 0) {
			return 'rgb(' + [200, color, color] + ')';
		} else {
			return 'rgb(' + [color, 200, color] + ')';
		}
	};

	Sentiment.getGlobalColor = function(sentiment) {
		if (isNaN(sentiment)) {
			return '#808080'; // fallback to the neutral gray color @sentiment-color-neutral
		}

		return Sentiment.getGlobalColor.scale(sentiment);
	};

	Sentiment.getD3Color.scale = d3
		.scaleLinear()
		.domain([-1, 0, 1])
		.range([0, 200, 0]);

	Sentiment.getGlobalColor.scale = d3
		.scaleSqrt()
		.domain([-1, 0, 1])
		.interpolate(d3.interpolateRgb)
		.range(['#af3232', '#808080', '#3caf50']); // @sentiment-color-negative, @sentiment-color-neutral, @sentiment-color-positive

	return Sentiment;
});
